import type {
  CalibrationTestPoint,
  EditableFieldType
} from '@features/calibration/components/shared/CalibrationEditableCell/types';

export const getEditableInputDataAttributes = (
  _testType: string,
  point: CalibrationTestPoint,
  field: EditableFieldType
): Record<string, string | number> => {
  const rowValue = point.rowIndex ?? 0;
  return {
    'data-field': field,
    'data-point-id': point.id,
    'data-row': rowValue,
    'data-test-type': 'basic-reading'
  };
};
